



















import AddToHomeScreenBanner from '@/components/AddToHomeScreenBanner.vue'
import AddToHomeScreenPopup from '@/components/popup/btt/AddToHomeScreen.vue'
import popupHandler from '@/mixins/popupHandler'
import {ACTION_NAME, CLOSE_BANNER_ACTION_NAME, CLOSE_POPUP_ACTION_NAME} from '@/constants/add-to-home-screen'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')
const userAction = namespace('userAction')

@Component({
  components: {AddToHomeScreenPopup, AddToHomeScreenBanner},
})
export default class AddToHomeScreenHandler extends Mixins(popupHandler) {
  @Prop({default: false, type: Boolean}) isMenu: boolean

  @userAgent.State('isKakaoBrowser') isKakaoBrowser: boolean
  @userAgent.State('isInAppBrowser') isInAppBrowser: boolean
  @userAgent.Getter('isMobile') isMobile: boolean
  @userAgent.Getter('isIOS') isIOS: boolean
  @userAgent.Getter('isAndroid') isAndroid: boolean
  @userAgent.Getter('isChromeBrowser') isChromeBrowser: boolean
  @userAgent.Getter('isSafariBrowser') isSafariBrowser: boolean
  @userAgent.Getter('isSamsungBrowser') isSamsungBrowser: boolean
  @userAgent.Getter('availableAddToHomeScreen') availableAddToHomeScreen: boolean
  @userAction.Mutation('setActions') setActions: (payload: string) => void
  @userAction.Mutation('removeActions') removeActions: (payload: string) => void
  @userAction.State('actions') actions: string[]
  @userAction.State('routeFrom') routeFrom: string
  @userAction.State('routeAction') routeAction: string
  @userAction.Getter('isAddedHomeScreen') isAddedHomeScreen: boolean

  get visibleBanner(): boolean {
    return !this.isUserClosedBanner && (this.availableAddToHomeScreen || this.isKakaoBrowser)
  }

  get visiblePopup(): boolean {
    return !this.isUserClosedPopup && (this.isAndroid && this.isChromeBrowser || this.isSamsungBrowser)
  }

  get isVisiblePage(): boolean {
    const visiblePageList: string[] = ['home', 'sign-in']
    const routeName = this.$route.name || ''
    return visiblePageList.includes(routeName)
  }

  get isUserClosedBanner(): boolean {
    return this.actions.includes(CLOSE_BANNER_ACTION_NAME)
  }

  get isUserClosedPopup(): boolean {
    return this.actions.includes(CLOSE_POPUP_ACTION_NAME)
  }

  get isFromKakao(): boolean {
    return this.routeFrom === 'kakao' && this.routeAction === ACTION_NAME
  }

  get isFromLanding(): boolean {
    return this.routeFrom === 'landing'
  }

  get redirectFtpLink(): string {
    return `${process.env.VUE_APP_REDIRECT_FTP_LINK}`
  }

  get redirectChromeLink(): string {
    const APP_URL = window?.location?.host
    return `intent://${APP_URL}/?from=kakao&action=${ACTION_NAME}#Intent;scheme=http;package=com.android.chrome;end`
  }

  @Watch('isFromKakao', {immediate: true})
  __isFromKakao(value) {
    if(!this.isMenu) {
      if(value) {
        this.removeActions(CLOSE_POPUP_ACTION_NAME)
        this.onRemoveBanner()
      } else {
        this.onRemovePopup()
      }
    }
  }

  @Watch('visiblePopup', {immediate: true})
  __visiblePopup(value) {
    if(value) {
      this.openPopup('addHomeScreen')
    } else {
      this.closePopup('addHomeScreen')
    }
  }

  @Watch('popupStatus.addHomeScreen', {immediate: true})
  '__popupStatus.addHomeScreen'(value) {
    if(!value) {
      this.onRemovePopup()
    }
  }

  onRemoveBanner() {
    this.setActions(CLOSE_BANNER_ACTION_NAME)
  }

  onRemovePopup() {
    this.setActions(CLOSE_POPUP_ACTION_NAME)
  }

  onAddToHome() {
    if(this.isKakaoBrowser || this.isInAppBrowser) {
      this.reOpenAvailableAddToHomeScreenBrowser()
    } else if(this.isAndroid && this.isChromeBrowser || this.isSamsungBrowser) {
      this.onRemoveBanner()
      this.removeActions(CLOSE_POPUP_ACTION_NAME)
      this.replaceRouterHome()
    } else if(this.isSafariBrowser) {
      this.removeActions(CLOSE_BANNER_ACTION_NAME)
      this.replaceRouterHome()
    }
  }

  replaceRouterHome() {
    if(!this.isVisiblePage) {
      this.$router.replace({name: 'home'}).catch((e) => e)
    }
  }

  reOpenAvailableAddToHomeScreenBrowser() {
    if(this.isIOS) {
      this.setLocationHref(this.redirectFtpLink)
    } else if(this.isAndroid) {
      this.setLocationHref(this.redirectChromeLink)
    }
  }

  setLocationHref(link) {
    location.href = link
  }
}
